var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';
import { FormText } from '@ally/metronome-ui';
import { validatePassword, validatePasswordV2 } from '../../validations';
import { useRegisterError } from '../../utils';
import PasswordStrengthMeter from './PasswordStrengthMeter';
import PasswordContextualHelper from './PasswordContextualHelper';
// Ensures the Meter and Contextual help always align with the FormText component
const StyledWrapper = styled.div `
  max-width: 500px;
`;
const NewPassword = (_a) => {
    var { 
    // NOTE: for instances where a NEW password is being created,
    // NOT for use when an existing password is being entered
    name, label = 'New password', username, shouldUseV2Validations = true } = _a, // DAO may need to use old validations
    props = __rest(_a, ["name", "label", "username", "shouldUseV2Validations"]);
    const [field, meta /* , helpers */] = useField({
        name,
        validate: password => {
            if (shouldUseV2Validations) {
                return validatePasswordV2(password, username);
            }
            return validatePassword(password, username);
        },
    });
    const { refValue } = useRegisterError(meta.error);
    const errorMessage = meta.touched ? meta.error : '';
    const ariaLabel = `${label}. Password requirements are 8 to 50 characters with no spaces, at least one letter, and at least one number, and your password is case sensitive.`;
    return (React.createElement(StyledWrapper, null,
        React.createElement(FormText, Object.assign({ adornment: "passwordMask", "aria-label": ariaLabel, "aria-required": true, "data-allytmfn": "new-password", "data-testid": "create-new-password", errorNotification: { message: errorMessage }, inputType: "password", labelContent: label, ref: refValue, required: true, title: "Password", variant: "input" }, field, props)),
        React.createElement(PasswordStrengthMeter, { password: field.value }),
        React.createElement(PasswordContextualHelper, { password: field.value, shouldUseV2Validations: shouldUseV2Validations })));
};
export default NewPassword;
//# sourceMappingURL=NewPassword.js.map